<script setup>
import { ref } from "vue";

import UserSingle from "../components/users/UserSingle";
import UserAddModal from "../components/modals/UserAddModal";
import { useUserState } from "@/stores/user-state";
import { getUsers } from '../functions/Users';

import Grid from "../components/Grid.vue";



const userStore = useUserState();

(async function () {
  userStore.users = await getUsers();
})();

</script>

<template>
  <div class="dashboard content__inside--small">
    <div class="content__header">
      <div>
        <h1>Users</h1>
        <p>Add, remove and edit users</p>
      </div>
    </div>
    <Grid>
      <div class="grid-item">
        <div class="grid-item__header">
          <h3>All Users</h3>
          <UserAddModal></UserAddModal>
        </div>
        <ul>
          <UserSingle v-for="user in userStore.users" :user="user"></UserSingle>
        </ul>
      </div>
    </Grid>
  </div>
</template>

<style scoped lang="scss">
.grid-item {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
